import React, { useEffect } from 'react';
import ReactGA, { GaOptions } from 'react-ga';
import { RouteComponentProps } from 'react-router-dom';

import { CONFIG } from '../../meta/types/config';

if (CONFIG.googleAnalytics.enable) {
  ReactGA.initialize(CONFIG.googleAnalytics.trackingID);
}

export const withTracker = <P extends RouteComponentProps>(
  WrappedComponent: React.ComponentType<P>,
  options: GaOptions = CONFIG.googleAnalytics.options,
) => {
  const trackPage = (page: string) => {
    ReactGA.set({ page, ...options });
    ReactGA.pageview(page);
  };

  return (props: P) => {
    useEffect(() => {
      trackPage(props.location.pathname + props.location.search);
      // eslint-disable-next-line
    }, [props.location.pathname, props.location.search]);

    return <WrappedComponent {...props} />;
  };
};

export default withTracker;
